/**
 * The role model the UI renders against — a typed mirror of the backend RBAC roles. The browser
 * bundle deliberately does NOT import @senesight/core (it carries Node-only code: crypto, pg). To
 * guarantee these never drift from the source of truth, roles.test.ts binds this list to
 * @senesight/core's ROLES (that test runs in Node, where importing core is fine).
 */
export const ROLES = ["admin", "delivery-lead", "sponsor", "client-viewer", "readonly"] as const;
export type Role = (typeof ROLES)[number];

export function isRole(value: unknown): value is Role {
  return typeof value === "string" && (ROLES as readonly string[]).includes(value);
}
